import React from "react";
import Card from "@mui/material/Card";
import { Backdrop, Button, CircularProgress, Grid, Modal, Typography, useMediaQuery, useTheme } from "@mui/material";
import CDropDown from "../../../basecomp/components/CDropDown";
import CButton from "../../../basecomp/components/CButton3";
import CChooseFile from "../../../basecomp/components/CChooseFile";
import CBackdrop from "../../../basecomp/components/CBackDrop";
import UploadLabelVM from "../viewmodel/UploadLabelVM";
import CTable2 from "../../../basecomp/components/CTable2";
import WarehouseLocationVM from "../viewmodel/WarehouseLocationVm";
import { useTranslation } from "react-i18next";
import LabelIcon from "@mui/icons-material/Label";
import WarehouseIcon from "@mui/icons-material/Warehouse";
import CloudUploadIcon from "@mui/icons-material/CloudUpload";
import { Box } from "@mui/system";
import CText from "../../../basecomp/components/CText";
import { CheckCircle } from "@mui/icons-material";

const UploadLabelView = () => {
  const { t } = useTranslation();
  const theme = useTheme();
  const isXs = useMediaQuery(theme.breakpoints.down("sm"));
  const {
    sizeOptions,
    sLocOptions,
    handleSizeChange,
    handleStorageLocationChange,
    handleSampleFileDownload,
    handleFileChoose,
    handleLabelFileUpload,
    isUploading,
    alertModelOpen,
    responseMessage
  } = UploadLabelVM();
  const {
    wareHouseData,
    infoHeadData,
    infoRowData,
    warehouseLoading,
    handleSampleWarehouseFileDownload,
  } = WarehouseLocationVM();

  return (
    <>
      <CBackdrop cOpen={isUploading} />

      <Grid
        item
        xs={10}
        sm={10}
        md={10}
        lg={10}
        xl={10}
        sx={{ margin: "6em 0.5em 0.5em 0.5em" }}
      >
        <Card sx={{ padding: isXs ? "1em .5em" : "1em 2.5em" }}>
          <Grid
            container
            style={{
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
            }}
          >
            <Grid
              container
              item
              xs={12}
              sm={12}
              md={12}
              lg={12}
              xl={12}
              justifyContent="right"
              marginBottom={2}
              gap={2}
            >
              <CButton
                cSrc={<LabelIcon />}
                cIsMain={true}
                cTooltipText={t("label_download")}
                cOnClick={handleSampleFileDownload}
              />
              <CButton
                cSrc={<WarehouseIcon />}
                cIsMain={true}
                cTooltipText={t("warehouse_download")}
                cOnClick={handleSampleWarehouseFileDownload}
              />
            </Grid>
            <Box sx={{ display: "flex", width: "100%" }}>
            <CDropDown
              cHelperText={t("size")}
              cData={sizeOptions}
              cIsOptionName={"size"}
              cOnChange={handleSizeChange}
              cFullWidth={true}
              cIsRequired={true}
            />
            <CDropDown
              cHelperText={t("Storage Location")}
              cData={sLocOptions}
              cIsOptionName="sloc"
              cOnChange={handleStorageLocationChange}
              cFullWidth={true}
              cIsRequired={true}
              //cDefaultValue={selectedSLoc}
            />
          </Box>
          <CChooseFile
            cFileType="XCL"
            cTooltipText={t("file")}
            cHelperText={t("file_type")}
            cHandleFileChange={handleFileChoose}
            cFullWidth={true}
            cIsRequired={true}
          />
          <Grid
            container
            item
            xs={12}
            sm={12}
            md={12}
            lg={12}
            xl={12}
            justifyContent="center"
            style={{ paddingBottom: "2.5em", marginTop: isXs ? "1rem" : "0" }}
          >
            <CButton
              cSrc={<CloudUploadIcon />}
              cIsMain={true}
              cTooltipText={t("upload_btn")}
              cOnClick={handleLabelFileUpload}
              disabled={isUploading}
            />
          </Grid>
      </Grid>
      {wareHouseData.length > 0 && (
        <CTable2
          cHeaderData={infoHeadData}
          cRowData={infoRowData}
          cActualData={wareHouseData}
          cIsPagination={true}
          cSmallSize={true}
        />
      )}
    </Card >
        
      </Grid >

      <Backdrop
  open={warehouseLoading}
  sx={{
    zIndex: (theme) => theme.zIndex.drawer + 999 // force above everything
  }}
>
  <CircularProgress />
</Backdrop>
      <Modal
        open={alertModelOpen}
        onClose={(e, reason) => {
          if (reason === "backdropClick") return;
        }}
      >
        <Box
          sx={{
            position: "absolute",
            top: "50%",
            left: "50%",
            transform: "translate(-50%, -50%)",
            width: 340,
            bgcolor: "#fff",
            borderRadius: "16px",
            boxShadow: "0 10px 30px rgba(0,0,0,0.2)",
            p: 4,
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
            textAlign: "center",
          }}
        >
          {/* Icon */}
          <CheckCircle
            sx={{ fontSize: 60, color: "#4caf50", mb: 1.5 }}
          />

          {/* Title */}
          <Typography
            sx={{
              fontSize: "20px",
              fontWeight: 600,
              mb: 1,
            }}
          >
            Success
          </Typography>

          {/* Message */}
          <Typography
            sx={{
              fontSize: "14px",
              color: "#666",
              mb: 3,
            }}
          >
            {responseMessage}
          </Typography>

          {/* Button */}
          <Button
            onClick={() => window.location.reload()}
            sx={{
              width: "100%",
              backgroundColor: "#0D2C6C",
              color: "#fff",
              borderRadius: "10px",
              textTransform: "none",
              fontWeight: 500,
              py: 1,
              "&:hover": {
                backgroundColor: "#0A2458", // slightly darker for hover
              },
            }}
          >
            OK
          </Button>
        </Box>
      </Modal>
      
    </>
  );
};

export default UploadLabelView;